import { useEffect } from "react";
import { useUser } from "src/atoms/user";
import { applyAuthTabSyncAction, getAuthTabSyncAction } from "src/utils/authTabSync";
import { getLoginToken, keyToken } from "src/utils/localStorage";

export const AuthTabSync = () => {
  const { user } = useUser();

  useEffect(() => {
    const syncWithToken = (token: string | null) =>
      applyAuthTabSyncAction(getAuthTabSyncAction(user, token));

    // Storage events are ignored while user is null, so the token may have changed while it was verified.
    syncWithToken(getLoginToken());

    const onStorage = (event: StorageEvent) => {
      // key is null when another tab calls localStorage.clear() on logout.
      if (event.key !== keyToken && event.key !== null) {
        return;
      }

      syncWithToken(event.newValue);
    };

    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [user]);

  return null;
};
